import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderLineItemDetails = (props: OrderLineItemDetailsProps) => {
  const {
    lineItemName,
    lineItemDescription,
    removedIngredientsText,
    addedIngredientsText,
    textAlignment = 'left',
    isProductAvailable = true,
  } = props;

  const textStyles = textAlignment === 'center' ? styles.textCenter : undefined;

  return (
    <View style={styles.container}>
      <BodyText
        sizeMatch={['18']}
        style={[
          textStyles,
          isProductAvailable ? undefined : styles.unavailableProductText,
        ]}
      >
        {lineItemName}
      </BodyText>

      {isProductAvailable ? (
        <View>
          {addedIngredientsText ? (
            <BodyText sizeMatch={['14']} style={textStyles}>
              {addedIngredientsText}
            </BodyText>
          ) : null}

          {removedIngredientsText ? (
            <BodyText sizeMatch={['14']} style={textStyles}>
              {removedIngredientsText}
            </BodyText>
          ) : null}

          {lineItemDescription ? (
            <BodyText sizeMatch={['14']} style={textStyles}>
              {lineItemDescription}
            </BodyText>
          ) : null}
        </View>
      ) : (
        <BodyText
          sizeMatch={['14']}
          style={[textStyles, styles.unavailableProductText]}
        >
          <FormattedMessage {...messages.unavailable} />
        </BodyText>
      )}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    rowGap: theme.spacing['1'],
  },
  textCenter: {
    textAlign: 'center',
  },
  unavailableProductText: {
    opacity: 0.4,
  },
});

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  unavailable: {
    defaultMessage: 'Currently unavailable',
    description: 'Order Line Item Details | Unavailable text',
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type OrderLineItemDetailsProps = {
  lineItemName: string;
  lineItemDescription: string;
  addedIngredientsText: string | null;
  removedIngredientsText: string | null;
  textAlignment?: 'left' | 'center';
  isProductAvailable?: boolean;
};
